<section>
  <div class="sampling-log" *ngIf="productionOrders$ | async as productionOrders">
    <div class="sampling-log__sidebar-container">
      <app-scrollable-sidebar
        [itemList]="productionOrders"
        [scrollTo]="initialProductionOrderIndex"
        (searchBarValueChanged)="searchBarValueChanged($event)"
      >
        <app-order-sidebar-item
          *appListItem="let item"
          [item]="item"
          [isItemActive]="isItemActive(item)"
          (itemSelected)="onOrderItemSelect($event)"
        ></app-order-sidebar-item>
      </app-scrollable-sidebar>
    </div>

    <div class="sampling-log__details">
      <ng-container *ngIf="isLoading; else logDetails">
        <lib-loading-indicator></lib-loading-indicator>
      </ng-container>

      <ng-template #logDetails>
        <div *ngIf="productionOrders?.length > 0">
          <app-sampling-log-details [samplingLogDetails]="samplingDataListViewModel"></app-sampling-log-details>
        </div>
      </ng-template>
    </div>
  </div>
</section>
